// Deep links into WHG Docs — a document the Salesforce intake console
// points at, a matter someone pasted into a chat — used to end on the
// landing page: a 401 sends the browser to "/", the Salesforce sign-in
// round-trips, and AuthRedirect then navigates to Matters/Home with no
// memory of where the person was going (Matthew, 2026-10-19: "it took me
// to my homepage when I first logged in").
//
// The failed-refresh redirect remembers the path here; AuthRedirect
// consumes it after a successful session check. sessionStorage is per
// tab and dies with the browser session, the same reasoning as the
// signed-out flag. An explicit sign-out clears it, so "Sign out" never
// bounces someone back into the page they just left.

export const RETURN_TO_KEY = "dms_return_to";

/** Only a same-origin path: starts with one slash, never a scheme or "//host". */
export function isSafeReturnPath(path) {
  return typeof path === "string" && /^\/(?!\/)/.test(path) && path !== "/";
}

export function rememberReturnTo(path) {
  if (!isSafeReturnPath(path)) return;
  try {
    sessionStorage.setItem(RETURN_TO_KEY, path);
  } catch (error) {
    console.warn("Could not remember where to return after sign-in:", error);
  }
}

export function consumeReturnTo() {
  try {
    const path = sessionStorage.getItem(RETURN_TO_KEY);
    if (path !== null) sessionStorage.removeItem(RETURN_TO_KEY);
    return isSafeReturnPath(path) ? path : null;
  } catch (error) {
    return null;
  }
}

export function forgetReturnTo() {
  try {
    sessionStorage.removeItem(RETURN_TO_KEY);
  } catch (error) {
    // nothing to forget
  }
}
